async function blobToBase64(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result as string);
    };
  });
}

async function imageConvert(image: File | string): Promise<string> {
  if (image instanceof File) {
    const base64Image = await blobToBase64(image);
    return base64Image;
  }
  return image;
}

export default imageConvert;
